import { leadsModals } from './user/leads/leads-modals';
import { modalUser } from './user/modals/modal-user';
import { changePassword } from './user/profile/change-password';
import { edit } from './user/profile/edit';
import { manage } from './user/profile/manage';
import { initProfileOrganization } from './user/profile/organization/main';
import { resettingPassword } from './user/profile/resetting-password';

export const user = () => {
  manage();
  edit();
  changePassword();
  resettingPassword();

  if (
    document.querySelector('header')
    && document.querySelector('.modal-user')
  ) {
    modalUser('.modal-user');
  }

  if (document.getElementById('lead-modals')) {
    leadsModals();
  }

  if (document.getElementById('user-profile-team')) {
    initProfileOrganization();
  }
};
